import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { CarouselComponent } from './carousel.component';


@NgModule({
	declarations: [
		CarouselComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		AnalyticsModule,
		DzButtonModule,
		GenericDirectivesModule
	],
	exports: [
		CarouselComponent
	]
})
export class CarouselModule { }
